import { DashboardStorePanelFilterSectionExport } from "./DashboardStorePanelFilterSectionExport";

export function ExportOrSendPopup({
  onClose,
  onChange,
  createPopupQuestion,
  removePopupQuestion,
  onExport,
}) {
  return (
    <div className="popup-container" style={{ zIndex: 11 }}>
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">
            Exportación o envío de fichero
          </span>
          <button className="popup-action-icon close-icon" onClick={onClose}>
            <img src="/images/close-white.svg" loading="lazy" alt="Icon" />
          </button>
        </div>
        <div
          className="tab-content ap-content"
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div className="container-panel">
            <DashboardStorePanelFilterSectionExport
              onChange={(type, mail) => onChange(type, mail)}
              createPopupQuestion={createPopupQuestion}
              removePopupQuestion={removePopupQuestion}
              onExport={(type, mail) => onExport(type, mail)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
